import { TIME } from "../../utils/time-constants";

export function durationMinutes(duration?: number) {
  if (!duration) {
    return "";
  }

  const hours = Math.floor(duration / TIME.SECONDS_IN_MINUTE);
  const minutes = duration % TIME.SECONDS_IN_MINUTE;

  // TODO: format using intl
  const unit_h = hours > 1 ? "hours" : "hour";
  const unit_m = minutes > 1 ? "minutes" : "minute";

  return (hours > 0 ? `${hours} ${unit_h}` : "") + (minutes > 0 ? ` ${minutes} ${unit_m}` : "");
}
